import styled from "styled-components";

type AvatarCardProps = {
  title: string
  subtitle: string
}
const Wrapper = styled.div`
  background: white;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.h2`
  font-size: 1.25rem;
  margin-bottom: 8px;
`;

const Subtitle = styled.p`
  font-size: 0.9rem;
  color: #666;
`;

export const AvatarCard = ( { title, subtitle }: AvatarCardProps) => {
  return ( 
    <Wrapper>
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
    </Wrapper>
  )
}
